<template>
  <!-- 标题配置组件
       @author: 王汝鹏
       @date: 2019-9-10
   -->
  <div class="setting-item">
    <el-form-item label="内容"> 
      <el-input type="textarea"
                :rows="10"
                v-model="title"
                placeholder="请输入内容"></el-input>
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 标题属性配置
     *  @description 将 labelName 字段映射到当前 title 计算属性
     *  @return {String}
     *  @author 王汝鹏
     *  @version 2019-09-10
     */
    ...mapComputed({
      title: { 
        parent: i => i.baseOption,
        attr: "labelName" 
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingContent.vue